import {
  Inject,
  Injectable,
  InjectionToken,
  ModuleWithProviders,
  NgModule,
} from '@angular/core';
import { BackendFetchTypes } from '../backend.model';
import { SearchCollections } from '../collections.model';

export type SearchTransformer<K extends keyof SearchCollections> = (
  value: BackendFetchTypes[K],
) => SearchCollections[K];

export type SearchTransformersMap = {
  [K in keyof SearchCollections]?: SearchTransformer<K>
};

export interface SearchFeature<K extends keyof SearchCollections> {
  readonly featureName: K;
  readonly transformer: SearchTransformer<K>;
}

export type SearchFeatures = ReadonlyArray<
  SearchFeature<keyof SearchCollections>
>;

export const SEARCH_FEATURES = new InjectionToken<SearchFeatures>(
  'Search Transformers',
);

@Injectable()
export class SearchManager {
  private transformers: SearchTransformersMap = {};

  transform<K extends keyof SearchCollections>(
    key: K,
    result: BackendFetchTypes[K],
  ): SearchCollections[K] {
    // FIXME: is the type casting really needed?
    return (this.transformers[key] as SearchTransformer<K>)(result);
  }

  addFeature<K extends keyof SearchCollections>({
    featureName,
    transformer,
  }: SearchFeature<K>) {
    this.transformers[featureName] = transformer as any; // FIXME: any type
  }
}

@NgModule({})
export class SearchRootModule {}

@NgModule({})
export class SearchFeatureModule {
  constructor(
    searchManager: SearchManager,
    @Inject(SEARCH_FEATURES) searchFeatures: SearchFeatures,
  ) {
    searchFeatures.map(f => searchManager.addFeature(f));
  }
}

@NgModule({})
export class SearchModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SearchRootModule,
      providers: [SearchManager],
    };
  }

  static forFeature(
    featureName: string,
    transformer: any,
  ): ModuleWithProviders {
    return {
      ngModule: SearchFeatureModule,
      providers: [
        {
          provide: SEARCH_FEATURES,
          multi: true,
          useValue: {
            featureName,
            transformer,
          },
        },
      ],
    };
  }
}
